import { AccomodationCategoryEnum } from '../../types/enums/product/accomodation-category.enum'
import { AffectedStaff } from '../../types/models/affectedStaff/affected-staff'

export const canAffectedStaffAccessQuestionnaire = (affectedStaff?: AffectedStaff | null) => {
  if (!affectedStaff) return false

  const isUsaJourney = affectedStaff.staffRequest.country?.code === 'USA'
  const hasHostFamilyJourney = affectedStaff.staffRequest.centers.some((center) =>
    center.centerToJourneys.some(
      ({ journey }) =>
        journey.date.product.accomodationCategory === AccomodationCategoryEnum.HOST_FAMILY
    )
  )

  return isUsaJourney && hasHostFamilyJourney
}
